<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter1" id="pgepubid00008">
<h2 class="c4">JUDICIAL <span class="fss1">OR</span> JUDICIARY ASTROLOGY</h2>
</div>
<p class="c10">Is a further pretence to discover or foretel <span class="fss">MORAL
EVENTS</span>, or such as have a dependence on the
<span class="fss">FREEDOM OF THE WILL</span>. In this department of
astrology we meet with all the idle conceits about
the <span class="fss">HORARY REIGN</span> of planets, the <span class="fss">DOCTRINE OF
HOROSCOPES</span>, the <span class="fss">DISTRIBUTION OF THE HOUSES</span>,
the <span class="fss">CALCULATION OF NATIVITIES</span>, <span class="fss">FORTUNES</span>,
<span class="fss">LUCKY</span> and <span class="fss">UNLUCKY HOURS</span>, and other ominous
fatalities.</p>
<p class="c11">The professors of this conjectural science maintain
“that the Heavens are one great book,
wherein God has written the history of the world;
and in which every man may read his own fortune
and the transactions of his time. This art, say
they, had its rise from the same hands as Astronomy
itself: while the ancient Assyrians, whose
serene unclouded sky favoured their celestial observations,
were intent on tracing the paths and
periods of the heavenly bodies; they discovered
a constant settled relation or analogy between them
and things below; and hence were led to conclude
these to be the <em class="calibre12">parcæ</em>, or fates or destinies, so much
talked of, which preside at our birth, and dispose
of our future fate.”</p>
<p class="c11"><span id="Page_28" title="28"></span>The study of Astrology, so flattering to human
curiosity, got early admission into the favour of
mankind, especially of the weak, ignorant, and
effeminate, whose follies induced the avaricious,
crafty, and designing knaves, to recommend and
promote it for their own private interest and advantage.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00009"><em class="calibre14">Origin of Astrology.</em></h3>
<p class="c19">We meet with the first accounts of Astrology
in Chaldea; and at Rome it was known by the
name of the <span class="sc">Babylonish calculation</span>; against
which Horace very wisely cautioned his readers—</p>
<div class="lg-container-b">
<div class="linegroup">
<div class="group">
<div class="line"><span xml:lang="la">—— nec Babylonios</span></div>
<div class="line"><span xml:lang="la">Tentaris numeros.—<cite class="calibre12">Lib.</cite> l. <em class="calibre12">od.</em> xi.</span></div>
</div>
</div>
</div>
<p class="c14">that is, consult not the tables or planetary calculations
used by Astrologers of Babylonish origin.
This therefore was the opinion of the Romans
on the subject of Astrology. Others have ascribed
the invention of this deception to the Arabs: be
this as it may, judicial Astrology has been too
much used by the priests of all nations to increase
their own power and emoluments.</p>
<p class="c11">The Egyptians, the Chaldeans, the Greeks and
Romans, furnish us with innumerable instances of
the extent to which Astrology was carried for interested
purposes. Brahmins in India, who take
upon themselves to be the arbiters of good and
evil hours, and who set an extravagant price
upon their pretended knowledge of planetary influence
and predictions, maintain their authority
at the present day by similar means. Nor among
the Christians, notwithstanding the enlightened
<span id="Page_29" title="29"></span>era in which we live, are we without our Astrologers,
as well as its admirers and advocates; for
though they may not have all pursued and adopted
the same technical method, still it is certain, that
whoever pretends to discover future events by other
means than through the light of Divine revelation,
may be properly classed under the species of judicial
Astrologers.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00010"><em class="calibre14">Astrological Schemes, &amp;c.</em></h3>
<p class="c19">Those who pretend to reduce the practice of
Astrology to a system, present the world with certain
schemes formed upon the <span class="sc">Aspects</span> of the
planets, and attribute certain qualities or powers
to each sign. Thus, to discover the influence of
the heavens over the life of a person, they erect
a <span class="fss">THEME</span>, at the given time of the moment the
person was born, by which the Astrologers pretend
to discover the star that presided, or in what part
of the hemisphere it was placed, when the individual
came into the world. The erection of this
<span class="fss">THEME</span> they perform, or at least pretend to reform,
with the assistance of the celestial globe, or planisphere,
with regard to the fixed stars; but with
respect to the planets, they do it with Astronomical
tables. To accomplish these, they have recourse
to a semi-circle, which they call <span class="fss">POSITION</span>, by
which they represent the six great circles passing through
the intersection of the Meridian and Horizon,
and dividing the Equator into twelve equal
parts. The spaces included between these circles,
are what they call the twelve <span class="fss">HOUSES</span>; which they
refer to the twelve triangles marked in their
<span id="Page_30" title="30"></span>theme; placing six of those <span class="fss">HOUSES</span> above and
six underneath the horizon.</p>
<p class="c11">The first of the <span class="fss">HOUSES</span> under the horizon toward
the East, they call the <span class="sc">Horoscope</span>, or
<span class="sc">House of Life</span>; the second, the <span class="sc">House of
Wealth</span>; the third, the <span class="sc">House of Brothers</span>;
the fourth, the <span class="sc">House of Parents</span>, &amp;c.; as is
clearly expressed in the following lines:</p>
<div class="lg-container-b">
<div class="linegroup">
<div class="group">
<div class="line"><span xml:lang="la">Vita, lucrum, fratres, genitor, natique Valetud,</span></div>
<div class="line"><span xml:lang="la">Uxor, Mors, pietas, et munia, amici inimici.</span></div>
</div>
</div>
</div>
<p class="c14">Which, translated by some English students in
Astrology, runs thus:</p>
<div class="lg-container-b">
<div class="linegroup">
<div class="group">
<div class="line">The first house shews life, the second wealth doth give;</div>
<div class="line">The third how brethren, fourth how parents live;</div>
<div class="line">Issue the fifth; the sixth diseases bring;</div>
<div class="line">The seventh wedlock, and the eighth death’s sting;</div>
<div class="line">The ninth religion; the tenth honour shews;</div>
<div class="line">Friendship the eleventh, and twelfth our woes.</div>
</div>
</div>
</div>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00011"><em class="calibre14">Table of the Twelve Houses.</em></h3>
<p class="c19">Astrologers draw their table of the <span class="fss">TWELVE
HOUSES</span> into a triple quadrangle prepared for the
purpose, of which there are four principal angles,
two of them falling equally upon the horizon, and
the other two upon the meridian, which angles are
sudivided into 12 triangles for the 12 houses, in
which they place the 12 signs of the Zodiac, to
each of which is attributed a particular quality,—viz.</p>
<dl class="dl_">
<dt class="calibre15">1.—</dt>
<dd class="calibre16"><span class="sc">Aries</span>, denoted by the sign ♈︎, is, in their extravagant opinion, 
    a masculine, diurnal, cardinal, equinoctial, easterly sign, hot and dry,—the day house of 
    Mars.
<div class="calibre2"><span id="Page_31" title="31"></span></div>
</dd>
<dt class="calibre15">2.—</dt>
<dd class="calibre16"><span class="sc">Taurus</span>, ♉︎, is a feminine, nocturnal, melancholy, bestial, 
    furious sign—cold and dry.
    </dd>
<dt class="calibre15">3.—</dt>
<dd class="calibre16"><span class="sc">Gemini</span>, ♊︎, is a masculine sign, hot and moist, diurnal, aërial, 
    human, double-bodied, &amp;c.
    </dd>
<dt class="calibre15">4.—</dt>
<dd class="calibre16"><span class="sc">Cancer</span>, ♋︎, is a feminine, nocturnal, phlegmatic sign, by nature 
    cold and moist, the only house of Luna.
    </dd>
<dt class="calibre15">5.—</dt>
<dd class="calibre16"><span class="sc">Leo</span>, ♌︎, is a sign, masculine, diurnal, bestial, choleric and 
    barren; a commanding, kingly sign—hot and dry, the only house of the sun.
    </dd>
<dt class="calibre15">6.—</dt>
<dd class="calibre16"><span class="sc">Virgo</span>, ♍︎, is a feminine, nocturnal, melancholy, and barren sign.
    </dd>
<dt class="calibre15">7.—</dt>
<dd class="calibre16"><span class="sc">Libra</span>, ♎︎, is a sign masculine, cardinal, equinoctial, diurnal, 
    sanguine and human, hot and moist.
    </dd>
<dt class="calibre15">8.—</dt>
<dd class="calibre16"><span class="sc">Scorpio</span>, ♏︎, is a feminine, nocturnal, cold and phlegmatic 
    northern sign.
    </dd>
<dt class="calibre15">9.—</dt>
<dd class="calibre16"><span class="sc">Sagittarius</span>, ♐︎, is a sign masculine, choleric, and diurnal, by 
    nature hot and dry.
    </dd>
<dt class="calibre15">10.—</dt>
<dd class="calibre16"><span class="sc">Capricorn</span>, ♑︎, is a feminine, nocturnal, melancholy, solstitial, 
    moveable, cardinal, and southern sign.
    </dd>
<dt class="calibre15">11.—</dt>
<dd class="calibre16"><span class="sc">Aquarius</span>, ♒︎, is a masculine, diurnal, fixed, sanguine, and human 
    sign.
    </dd>
<dt class="calibre15">12.—</dt>
<dd class="calibre16"><span class="sc">Pisces</span>, ♓︎, is a feminine, nocturnal, phlegmatic, northerly 
    double-bodied sign, the last of the twelve.
    </dd>
</dl>
<p class="c11"><span id="Page_32" title="32"></span>Having thus housed their signs and directed
them in their operations, they afterwards come to
enquire of their tenants, what planet and fixed
stars they have for <span class="fss">LODGERS</span>, at the moment of
the nativity of such person; from whence they
draw conclusions with regard to the future incident
of that person’s life. For if at the time of that
person’s nativity they find Mercury in 27° 52 min.
of Aquarius, and in the <em class="calibre12">sextile aspect</em> of the horoscope,
they pretend to foretel that that infant
will be a person of great sagacity, genius, and
understanding; and therefore capable of learning
the most sublime sciences.</p>
<p class="c11">Astrologers have also imagined, for the same
ridiculous purpose, to be in the same houses different
positions of the signs and planets, and from
their different aspects, opposition and conjunction,
and according to the rules and axioms they
have prescribed to themselves and invented, have
the sacrilegious presumption to judge, in <i class="calibre12"><span xml:lang="fr">dernier
resort</span></i>, of the fate of mankind, though their pretended
art or science is quite barren either of
proofs or demonstrations.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00012"><em class="calibre14">Signs to the Houses of the Planets.</em></h3>
<p class="c19">The planets have allowed themselves each, except
<span class="sc">Sol</span> and <span class="sc">Luna</span>, two signs for their houses;
to <span class="sc">Saturn</span>, Capricorn and Aquarius; to <span class="sc">Jupiter</span>,
Sagittarius and Pisces; to <span class="sc">Mars</span>, Aries and Scorpio;
to <span class="sc">Sol</span>, Leo; to <span class="sc">Venus</span>, Taurus and Libra;
to <span class="sc">Mercury</span>, Gemini and Virgo; and to <span class="sc">Luna</span>,
Cancer.</p>
<div class="calibre2">
<span id="Page_33" title="33"></span>
</div>
<div class="calibre2">
<h3 class="c18 sigil_not_in_toc" id="pgepubid00013"><em class="calibre14">Angles or Aspects of the Planets.</em></h3>
</div>
<p class="c19">By their continual mutations among the twelve
signs, the planets make several angles or aspects;
the most remarkable of which are the five following,
viz.—</p>
<p class="c11">☌ <span class="sc">Conjunction.</span>—Δ <span class="sc">Trine.</span>—☐ <span class="sc">Quadrate.</span>—⚹
<span class="sc">Sextile.</span>—☍ <span class="sc">Opposition.</span></p>
<p class="c11">A <span class="sc">Conjunction</span> is when two planets are in
one and the same degree and minute of a sign;
and this, according to Astrological cant, either
good or bad, as the planets are either friends or
enemies.</p>
<p class="c11">A <span class="sc">Trine</span> is when two planets are four signs, or
120 degrees distant, as <span class="sc">Mars</span> in twelve degrees
of <span class="sc">Aries</span>, and <span class="sc">Sol</span> in twelve degrees of <span class="sc">Leo</span>.
Here <span class="sc">Sol</span> and <span class="sc">Mars</span> are said to be in <em class="calibre12">Trine Aspect</em>.
And this is an aspect of perfect love and
friendship.</p>
<p class="c11">A <span class="sc">Quadrate Aspect</span> is when two planets are
three signs, or 90 degrees distant, as <span class="sc">Mars</span> in
10 degrees, and <span class="sc">Venus</span> in 10 degrees of <span class="sc">Leo</span>.
This particular aspect is of imperfect enmity, and
Astrologers say, that persons thereby signified,
may have jars at sometime, but of such a nature
as may be perfectly reconciled.</p>
<p class="c11">A <span class="sc">Sextile Aspect</span>, is when two planets are
two signs, or 60 degrees distant, as <span class="sc">Jupiter</span> in
15 degrees of Aries; and <span class="sc">Saturn</span> in 15 degrees
of Gemini; here <span class="sc">Jupiter</span> is in a sextile aspect
to <span class="sc">Saturn</span>. This is an aspect of friendship.</p>
<p class="c11">An <span class="sc">Opposition</span> is, when two planets are diametrically
opposite, which happens when they are
<span id="Page_34" title="34"></span>6 signs, or 180 degrees (which is one half of the
circle) asunder; and this is an aspect of perfect
hatred.</p>
<p class="c11">A <span class="sc">Partile Aspect</span>, is when two planets are in
a perfect aspect to the very same degree and
minute.</p>
<p class="c11"><span class="sc">Dexter Aspects</span>, are those which are contrary
to the succession of signs; as a planet, for
instance, in Aries, casts its sextile <i class="calibre12"><span xml:lang="la">dexter</span></i> to
Aquarius.</p>
<p class="c11"><span class="sc">Sinister Aspect</span>, is with the succession of
signs, as a planet in Aries, for example, casts its
sextile sinister in Gemini.</p>
<p class="c11">In addition to these, Astrologers play a number
of other diverting tricks; hence we read of the
<span class="sc">Application</span>—<span class="sc">Prohibition</span>—<span class="sc">Translation</span>—<span class="sc">Refrenation</span>—<span class="sc">Combustion</span>—<span class="sc">Exception</span>—<span class="sc">Retrogradation</span>,
&amp;c. of planets.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00014"><em class="calibre14">The Application of Planets.</em></h3>
<p class="c19">Application of the planets is performed by Astrologers
in three different ways.</p>
<p class="c11">1. When a light planet, direct and swift in its
motion, applies to a planet more ponderous and
slow in motion; as Mercury in 8° of Aries, and
Jupiter in 12° of Gemini, and both direct; here
Mercury applies to a sextile of Jupiter, by direct
application.</p>
<p class="c11">2. When they are both retrograde, as Mercury
in 20° of Aries, and Jupiter in 15° of Gemini;
here Mercury, the lighter planet, applies to the
sextile aspect of Jupiter; and this is by retrogradation.</p>
<p class="c11">3. When one of the planets is direct, and
<span id="Page_35" title="35"></span>the other retrograde; for example, if Mercury
were retrograde in 18° of Aries, and Jupiter
direct in 14° of Gemini; in this case Mercury applies
to a sextile of Jupiter, by a retrograde
motion.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00015"><em class="calibre14">Prohibition</em>,</h3>
<p class="c19">is when two planets are applying either by body or
aspect; and before they come to their <i class="calibre12"><span xml:lang="la">partile</span></i> aspect,
another planet meets with the aspect of the
former and prohibits it.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00016"><em class="calibre14">Separation</em>,</h3>
<p class="c19">is when two planets have been lately in conjunction,
or aspect, and are separated from it.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00017"><em class="calibre14">Translation of Light and Virtue</em>,</h3>
<p class="c19">is when a lighter planet separates from the body
or aspect of a heavier one, and immediately applies
to another superior planet, and so translates
the light and virtue of the first planet to that
which it applies to.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00018"><em class="calibre14">Refrenation</em>,</h3>
<p class="c19">is when a planet is applied to the body or aspect
of another; and, before it comes to it, falls retrograde,
and so refrains by its retrograde motion.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00019"><em class="calibre14">Combustion.</em></h3>
<p class="c19">A planet is said to be combust of Sol, when it
is within 8° 30″ of his body, either before or after
his conjunction: but Astrologers complain, that a
planet is more afflicted when it is applying to the
body of Sol, than when it is separating from combustion.</p>
<div class="calibre2">
<span id="Page_36" title="36"></span>
</div>
<div class="calibre2">
<h3 class="c18 sigil_not_in_toc" id="pgepubid00020"><em class="calibre14">Reception</em>,</h3>
</div>
<p class="c19">is when two planets are in each other’s dignities,
and it may either be by house, exultation, triplicity,
or term.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00021"><em class="calibre14">Retrogradation</em>,</h3>
<p class="c19">is when a planet moves backward from 20° to 9°,
8°, 7°, and so out of Taurus into Aries.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00022"><em class="calibre14">Frustration</em>,</h3>
<p class="c19">is when a swift planet applies to the body or aspect
of a superior planet; and before it comes to
it, the superior planet meets with the body or
aspect of some other planet.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00023"><em class="calibre14">The Dragon’s Head and Tail.</em></h3>
<p class="c19">To the seven planets, viz. <span class="sc">Saturn</span>, <span class="sc">Jupiter</span>,
<span class="sc">Mars</span>, <span class="sc">Sol</span>, <span class="sc">Venus</span>, <span class="sc">Mercury</span>, and <span class="sc">Luna</span>;
Astrologers add, two certain nodes or points,
called the Dragon’s head, distinguished by this
sign ☋, and the Dragon’s tail by ☊. In those
two extremities of the beast, our students in Astrology
place such virtues, that they can draw from
thence wealth, honour, preferments, &amp;c. enough
to flatter the avarice, ambition, vanity, &amp;c. of the
fools who follow them. Sensible, however, that
the admirers of this art support their principles
and defend their doctrines by examples founded
on their own experience and on the authority
of history; there is no necessity for us here to expose
the weakness and futility of their arguments.
<span id="Page_37" title="37"></span>Tully’s proof will suffice; who, amidst the darkest
clouds of superstition and ignorance, and in the
very heyday of paganism and idolatry, and whilst
religion itself seemed to countenance Astrology,
inveighs severely against it in <i class="calibre12"><span xml:lang="la">Lib. 2, de devinat.</span></i>
“<i class="calibre12"><span xml:lang="la">Quam multa ego Pompeis, quam multa Crasso,
quam multa huic ipsi Cæsari a Chaldæis dicta
memini, neminem eorum nisi senectute, nisi domi,
nisi cum clantate esse moriturum? ut mihi per
Mirum videatur quem quam extare, qui etiam nunc
credastis, quorum predicta quotidie videat re et
eventis refelli<a id="r9"></a><span class="c12" href="#/Text/Section0044#f9" title="Link target outside of Sample"><sup class="calibre13">[9]</sup></span>.</span></i>”</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00024"><em class="calibre14">Climacteric.</em></h3>
<p class="c19">Astrologers have used their best artifices, and employed
all the rules of their art, to render those
years of our age, which they call climacterics,
dangerous and formidable.</p>
<p class="c11">Climacterick from the Greek, <span xml:lang="grc">κλιμακτης</span>, which
means by a scale or ladder, is a critical year, or a
period in a man’s age, wherein, according to Astrological
juggling, there is some notable alteration
to arise in the body; and a person stands in
great danger of death. The first climacterick, say
they, is the seventh year of a man’s life; the rest
are multiples of the first, as 21, 49, 56, 63, and
84; which two last are called the grand climactericks,
and the danger more certain.</p>
<p class="c11">Marc Ficinus accounts for the foundation of
<span id="Page_38" title="38"></span>this opinion: he tells us there is a year assigned
for each planet to rule over the body of a man,
each in his turn; now Saturn being the most
<em class="calibre12">maleficent</em> (malignant) planet of all, every seventh
year, which falls to its lot, becomes very dangerous;
especially those of 63 and 84, when the person is
already advanced in years. According to this
doctrine, some hold every seventh year an established
climacteric; but others only allow the title
to those produced by the multiplication of the
climacterical space by an odd number, 3, 5, 7, 9,
&amp;c. Others observe every ninth year as a climacterick.</p>
<p class="c11">There is a work extant, though rather scarce,
by Hevelius, under the title of <cite class="calibre12"><span xml:lang="la">Annus Climactericus</span></cite>,
wherein he describes the loss he sustained
by his observatory, &amp;c. being burnt; which, it
would appear, happened in his grand climacterick.
Suetonius says, that Augustus congratulated his
nephew upon his having passed his first grand
climacterick, of which he was very apprehensive.</p>
<p class="c11">Some pretend that the climacterick years are
fatal to political bodies, which perhaps may be
granted, when they are proved to be so to natural
ones; for it must be obvious that the reason of
such danger can by no means be discovered, nor
what relation it can have with any of the numbers
above-mentioned. Though this opinion has a great
deal of antiquity on its side; Aulus Gellius says,
it was borrowed from the Chaldeans, who, possibly,
might receive it from Pythagoras, whose philosophy
turned much on numbers, and who imagined
an extraordinary virtue in the number 7.</p>
<p class="c11"><span id="Page_39" title="39"></span>The principal authors on the subject of climactericks,
are <span class="sc">Plato</span>, <span class="sc">Cicero</span>, <span class="sc">Macrobius</span>, <span class="sc">Aulus
Gellius</span>, among the ancients; <span class="sc">Argol</span>, <span class="sc">Magirus</span>,
and <span class="sc">Salmatius</span>, among the moderns.
<span class="sc">St. Augustine</span>, <span class="sc">St. Ambrose</span>, <span class="sc">Beda</span>, and
<span class="sc">Bœtius</span>, all countenance the opinion.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00025"><em class="calibre14">Lucky and Unlucky Days.</em></h3>
<p class="c19">Astrologers have also brought under their inspection
and controul the days of the year, which
they have presumed to divide into lucky and unlucky
days; calling even the sacred scriptures, and
the common belief of Christians, in former ages, to
their assistance for this purpose. They pretend
that the 14th day of the first month was a blessed
day among the Israelites, authorised therein, as
they pretend, by the several following passages out
of <cite class="calibre12">Exodus</cite>, c. xii. v. 18, 40, 41, 42, 51. <cite class="calibre12">Leviticus</cite>,
c. xxiii. v. 5. <cite class="calibre12">Numbers</cite>, c. xxviii. v. 16. “<em class="calibre12">Four
hundred and thirty years being expired of their
dwelling in Egypt, even in the self same day departed
they thence.</em>”</p>
<p class="c11">With regard to evil days and times, Astrologers
refer to <cite class="calibre12">Amos</cite>, c. 5, v. 13, and c. vi. v. 3. <cite class="calibre12">Ecclesiasticus</cite>,
c. ix. v. 12. <cite class="calibre12">Psalm</cite>, xxxvii. v. 19. <cite class="calibre12">Obadiah</cite>,
c. xii. <cite class="calibre12">Jeremiah</cite>, c. xlvi. v. 21, and to Job
cursing his birth day, chap. iii. v. 1 to 11. In confirmation
of which they also quote a calendar, extracted
out of several ancient Roman catholic
prayer books, written on vellum, before printing
was invented, in which were inserted the unfortunate
<span id="Page_40" title="40"></span>days of each month, as in the following
verses;—</p>
<div class="lg-container-b">
<div class="linegroup">
<div class="group">
<div class="line"><span class="sc">January.</span>—<i class="calibre12"><span xml:lang="la">Prima dies mensis, et septima truncat ensis.</span></i></div>
<div class="line"><span class="sc">February.</span>—<i class="calibre12"><span xml:lang="la">Quarta subit mortem, prosternit tertia fortem.</span></i></div>
<div class="line"><span class="sc">March.</span>—<i class="calibre12"><span xml:lang="la">Primus mandentem, disrumpit quarta bibentem.</span></i></div>
<div class="line"><span class="sc">April.</span>—<i class="calibre12"><span xml:lang="la">Denus et undenus est mortis vulnere plenus.</span></i></div>
<div class="line"><span class="sc">May.</span>—<i class="calibre12"><span xml:lang="la">Tertius occidit, et Septimus ora relidit.</span></i></div>
<div class="line"><span class="sc">June.</span>—<i class="calibre12"><span xml:lang="la">Denus Pallescit, quindenus fædera nescit.</span></i></div>
<div class="line"><span class="sc">July.</span>—<i class="calibre12"><span xml:lang="la">Ter denus mactat, Julii denus labefactat.</span></i></div>
<div class="line"><span class="sc">August.</span>—<i class="calibre12"><span xml:lang="la">Prima necat fortem, perditque secunda cohortem.</span></i></div>
<div class="line"><span class="sc">September.</span>—<i class="calibre12"><span xml:lang="la">Tertia Septembris, et denus fert mala membris.</span></i></div>
<div class="line"><span class="sc">October.</span>—<i class="calibre12"><span xml:lang="la">Tertius et denus, est sicut mors alienus.</span></i></div>
<div class="line"><span class="sc">November.</span>—<i class="calibre12"><span xml:lang="la">Scorpius est quintus, et tertius est vita tinctus.</span></i></div>
<div class="line"><span class="sc">December.</span>—<i class="calibre12"><span xml:lang="la">Septimus exanguis, virosus denus ut Anguis.</span></i></div>
</div>
</div>
</div>
<p class="c11">This poetry is a specimen of the rusticity and
ignorance at least of the times; and is a convincing
proof that Christianity had yet a very strong tincture
of the Pagan superstitions attached to it, and
which all the purity of the gospel itself, to this very
day, has not been able entirely to obliterate.</p>
<p class="c11">That the notion of lucky and unlucky days owes
its origin to paganism, may be proved from Roman
history, where it is mentioned that that very day
four years, the civil wars were begun by Pompey
the father; Cæsar made an end of them with his
son, Cneius Pompeius being then slain; and that
the Romans accounted the 13th of February an
unlucky day, because on that day they were overthrown
by the Gauls at Allia; and the Fabii attacking
the city of the Recii, were all slain with
the exception of one man: from the calendar of
Ovid’s “Fastorum,” <i class="calibre12"><span xml:lang="la">Aprilis erat mensis Græcis
auspicatissimus</span></i>; and from Horace, lib. 2, ode 13,
cursing the tree that had nearly fallen upon it;
<i class="calibre12"><span xml:lang="la">ille nefasto posuit die</span></i>.</p>
<p class="c11"><span id="Page_41" title="41"></span>The number of remarkable events that happened
on some particular days have been the principal
means of confirming both Pagans and Christians
in their opinion on this subject. For example,
Alexander the Great, who was born on the 6th of
April, conquered Darius and died on the same day.
The Emperor Bassianus Caracalla was born and
died on a sixth day of April. Augustus was
adopted on the 19th of August, began his Consulate,
conquered the Triumviri, and died the same day.</p>
<p class="c11">The Christians have observed that the 24th of
February was four times fortunate to Charles the
Fifth. That Wednesday was a fortunate day to
Pope Sixtus V. for on a Wednesday he was born,
on that day made a Monk, on the same day made
a General of his order, on that day created a Cardinal,
on that day elected Pope, and also on that
day inaugurated. That Thursday was a fatal day
to Henry VIII. King of England, and his posterity,
for he died on a Thursday; King Edward
VI. on a Thursday; Queen Mary on a Thursday;
and Queen Elizabeth on a Thursday. The French
have observed that the feast of Pentecost had been
lucky to Henry III. King of France, for on that
day he was born, on that day elected king of Poland,
and on that day he succeeded his brother
Charles IX. on the throne of France.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00026"><em class="calibre14">Genethliaci.</em></h3>
<div class="nf-center-c1">
<div class="nf-center2">
<div class="calibre2">(From <span xml:lang="grc">γενεθλη</span>, <em class="calibre12">origin</em>, <em class="calibre12">generation</em>, <em class="calibre12">nativity</em>.)</div>
</div>
</div>
<p class="c11">These, so called in Astrology, are persons who
erect Horoscopes; or pretend what shall befal a
<span id="Page_42" title="42"></span>man, by means of the stars which presided at his
nativity<a id="r10"></a><span class="c12" href="#/Text/Section0044#f10" title="Link target outside of Sample"><sup class="calibre13">[10]</sup></span>. The ancients called them <em class="calibre12">Chaldæi</em>,
and by the general name mathematici: accordingly
the several civil and canon laws, which we find
made against the mathematicians, only respect the
Genethliaci, or Astrologers; who were expelled
Rome by a formal decree of the senate, and yet
found so much protection from the credulity of the
people, that they remained unmolested. Hence
an ancient author speaks of them as <i class="calibre12"><span xml:lang="la">hominum
genus, quod in civitate nostra sempe et vetabitur,
et retinebitur</span></i>.</p>
<div class="lg-container-b">
<div class="linegroup">
<div class="group">
<div class="line"><span class="sc">Genethliacum</span>, (<em class="calibre12">Genethliac poem</em>,)</div>
</div>
</div>
</div>
<p class="c14">Is a composition in verse, on the birth of some
prince, or other illustrious person; in which the
poet promises him great honours, advantages,
successes, victories, &amp;c. by a kind of prophecy or
prediction. Such, for instance, is the eclogue of
Virgil to Pollio, beginning</p>
<div class="lg-container-b">
<div class="linegroup">
<div class="group">
<div class="line"><i class="calibre12"><span xml:lang="la">Sicelides Musæ, paulo majora Canamus.</span></i></div>
</div>
</div>
</div>
<p class="c14">There are also <em class="calibre12">Genethliac</em> speeches or orations,
made to celebrate a person’s birth day.</p>
<h3 class="c18 sigil_not_in_toc" id="pgepubid00027"><em class="calibre14">Barclay’s Refutation of Astrology.</em></h3>
<p class="c19">Astrological superstition, it is said, transcended
from the Chaldeans, who transmitted it to the
Egyptians, from whom the Greeks derived it,
whence it passed to the Romans, who, doubtless,
<span id="Page_43" title="43"></span>were the first to disseminate it over Europe, though
some will have it to be of Egyptian origin, and
ascribe the invention to <span class="sc">Cham</span>; but it is to the
Arabs that we owe it. At Rome, the people were
so infatuated with it, the Astrologers, or, as they
are called, the mathematicians, maintained their
ground in spite of all the edicts to expel them out
of the city<a id="r11"></a><span class="c12" href="#/Text/Section0044#f11" title="Link target outside of Sample"><sup class="calibre13">[11]</sup></span>.</p>
<p class="c11">The Brahmins introduced and practised this art
among the Indians, and thereby constituted themselves
the arbiters of good and evil hours, which
gives them vast authority, and in consequence of
this supererogation, they are consulted as Oracles,
and take good care they never sell their answers
but at a good price.</p>
<p class="c11">The same superstition, as we have already
shewn, has prevailed in more modern ages and
nations. The French historians remark, that, in
the time of Queen Catherine of Medicis, Astrology
was in so great repute, that the most inconsiderable
thing was not undertaken or done without
consulting the stars. And in the reigns of king
Henry III. and IV. of France, the predictions of
Astrologers were the common theme of the court
conversation.</p>
<p class="c11">This predominant humour in the French court
was well rallied by Barclay in his Argenis, lib. ii,
on account of an Astrologer who had undertaken
to instruct king Henry in the event of a war then
threatened by the faction of the Guises.</p>
<p class="c11">“You maintain,” says Barclay, “that the circumstances
<span id="Page_44" title="44"></span>of life and death depend on the place
and influence of the celestial bodies, at the time
when the child first comes to light; and yet you
own, that the heavens revolve with such vast rapidity
that the situation of the stars is considerably
changed in the least moment of time. What certainty
then can be in your art, unless you suppose
the midwives constantly careful to observe the
clock, that the minute of time may be conveyed
to the infant, as we do his patrimony? How often
does the mother’s danger prevent this care? And
how many are there who are not touched with this
superstition? But suppose them watchful to your
wish; if the child be long in delivery; if, as is
often the case, a hand or the head come first, and
be not immediately followed by the rest of the
body; which state of the stars is to determine for
him; that, when the head made its appearance, or
when the whole body was disengaged? I say
nothing of the common errors of clocks, and other
time-keepers, sufficient to elude all your cares.</p>
<p class="c11">“Again, why are we to regard only the stars at
his nativity, and not those rather which shone when
the fœtus was animated in the womb? and why
must those others be excluded, which presided
while the body remained tender, and susceptible of
the weakest impression, during gestation?</p>
<p class="c11">“But setting this aside, and supposing, withal,
the face of the heavens accurately known, whence
arises this dominion of the stars over our bodies
and minds, that they must be the arbiters of our
happiness, our manner of life, and death? Were
all those who went to battle, and died together,
<span id="Page_45" title="45"></span>born under the same position of the heavens? and
when a ship is to be cast away, shall it admit no
passengers but those doomed by the stars to suffer
shipwreck? or rather, do not persons born under
every planet go into the combat, or aboard the
vessel; and thus, notwithstanding the disparity of
their birth, perish alike? Again, all who were
born under the same configuration of the stars do
not live or die in the same manner. All, who were
born at the same time with the king, monarchs?
Or are all even alive at this day? I saw M.
Villeroy here; nay, I saw yourself: were all that
came into the world with him as wise and virtuous
as he; or all born under your own stars, astrologers
like you? If a man meet a robber, you will
say he was doomed to perish by a robber’s hand;
but did the same stars, which, when the traveller
was born, subjected him to the robber’s sword, did
they likewise give the robber, who perhaps was
born long before, a power and inclination to kill
him? For you will allow that it is as much owing
to the stars that the one kills, as that the other is
killed. And when a man is overwhelmed by the
fall of a house, did the walls become faulty, because
the stars had doomed him to perish thereby;
or rather, was his death not owing to this, that
the walls were faulty? The same may be said
with regard to honours or employ: because the
stars which shone at a man’s nativity, promised
him preferment; could those have an influence
over other persons not born under them, by whose
suffrages he was to rise? or how do the stars at
one man’s birth annul, or set aside, the contrary
<span id="Page_46" title="46"></span>influences of other stars, which shone at the birth
of another?</p>
<p class="c11">“The truth is, supposing the reality of all the
planetary powers; as the sun which visits an infinity
of bodies with the same rays, has not the same
effect on all, as some things are hardened thereby,
as clay; others softened, as wax; some seeds cherished,
others destroyed; the tender herbs scorched
up, others secured by their coarser juice: so,
where so many children are born together, like a
field tilled so many different ways, according to
the various health, habitude, and temperament of
the parents, the same celestial influx must operate
differently. If the genius be suitable and towardly,
it must predominate therein: if contrary, it will
only correct it. So that to foretel the life and
manners of a child, you are not only to look into
the heavens, but into the parents, into the fortune
which attended the pregnant mother, and a thousand
other circumstances utterly inaccessible.</p>
<p class="c11">“Further, does the power that portends the
new-born infant a life, for instance of forty years;
or perhaps a violent death at thirty; does that
power I say, endure and reside still in the heavens,
waiting the destined time, when, descending upon
earth, it may produce such an effect? Or is it
infused into the infant himself; so that being cherished,
and gradually growing up together with
him, it bursts forth at the appointed time, and
fulfils what the stars had given it in charge? Exist
in the heavens it cannot; in that depending
immediately on a certain configuration of the stars;
when that is changed the effect connected with it
<span id="Page_47" title="47"></span>must cease, and a new, perhaps a contrary one,
takes place. What repository have you for the
former power to remain in, till the time comes for
its delivery? If you say it inherits or resides in
the infant, not to operate on him till he be grown
to manhood; the answer is more preposterous than
the former; for this, in the instance of a shipwreck,
you must suppose the cause why the winds arise,
and the ship is leaky, or the pilot, through ignorance
of the place, runs on a shoal or a rock. So
the farmer is the cause of the war that impoverishes
him; or of the favourable season, which
brings him a plenteous harvest.</p>
<p class="c11">“You boast much of the event of a few predictions,
which, considering the multitude of those
your art has produced, plainly confess its impertinency.
A million of deceptions are industriously
hidden and forgot, in favour of some eight or ten
things which have succeeded<a id="r12"></a><span class="c12" href="#/Text/Section0044#f12" title="Link target outside of Sample"><sup class="calibre13">[12]</sup></span>. Out of so many
conjectures, it must be preternatural if some do
not hit; and it is certain, that, by considering you
only as guessers, there is no room to boast you
have been successful therein. Do you know what
fate awaits France in this war; and yet are not
apprehensive what shall befal yourself? Did you
not foresee the opposition I was this day to make
you? If you can say whether the king will vanquish
<span id="Page_48" title="48"></span>his enemies, find out first whether he will
believe you.</p>
<p class="c11"><span class="sc">Des Cartes</span> and <span class="sc">Agrippa</span>, as they inveigh
much against some other sciences, especially
Agrippa, so the latter of them does not favour or
spare astronomy, but particularly astrology, which
he says, is an art altogether fallacious, and that
all vanities and superstitions flow out of the bosom
of astrology, their whole foundation being upon
conjectures, and comparing future occurrences
by past events, which they have no pretence for,
since they allow that the heavens never have been,
nor ever will be, in one exact position since the
world commenced, and yet they borrow the effects
and influence of the stars from the most remote
ages in the world, beyond the memory of things,
pretending themselves able to display the hidden
natures, qualities, &amp;c. of all sorts of animals,
stones, metals, and plants, and to shew how the
same does depend on the skies, and flow from the
stars. Still Eudoxus, Archelaus, Cassandrus,
Halicarnassus, and others, confess it is impossible,
that any thing of certainty should be discovered
by the art of judicial astrology, in consequence of
the innumerable co-operating causes that attend
the heavenly influences; and Ptolemy is also of
this opinion. In like manner those who have
prescribed the rules of judgments, set down their
maxims so various and contradictory, that it is
impossible for a prognosticator out of so many
various and disagreeable opinions, to be able to
pronounce any thing certain, unless he is inwardly
inspired with some hidden instinct and sense of
<span id="Page_49" title="49"></span>future things, or unless by some occult and latent
communication with the devil. And antiquity
witnesseth that Zoroaster, Pharaoh, Nebuchadnezzar,
Cæsar, Crassus, Pompey, Diatharus, Nero,
Julian the Apostate, and several others most
addicted to astrologers’ predictions, perished unfortunately,
though they were promised all things
favourable and auspicious. And who can believe
that any person happily placed under Mars, being
in the ninth, shall be able to cast out devils by his
presence only; or he who hath Saturn happily
constituted with Leo at his nativity, shall, when
he departs this life, immediately return to heaven,
yet are the heresies maintained by Petrus Aponensis,
Roger Bacon, Guido, Bonatus, Arnoldus
de Villanova, philosophers; Aliacensis, cardinal
and divine, and many other famous Christian doctors,
against which astrologers the most learned
Picus Mirandola wrote twelve books, so fully as
scarcely one argument is omitted against it, and
gave the death blow to astrology! Amongst the
ancient Romans it was prohibited, and most of
the holy fathers condemned, and utterly banished
it out of the territories of Christianity, and in the
synod of Martinus it was anathematized. As to
the predictions of Thales, who is said to have
foretold a scarcity of olives and a dearth of oil,
so commonly avouched by astrologers to maintain
the glory of their science, Des Cartes answers
with an easy reason and probable truth, that Thales
being a great natural philosopher, and thereby
well acquainted with the virtue of water, (which
he maintained was the principle of all things,) he
<span id="Page_50" title="50"></span>could not be ignorant of the fruits that stood the
most in need of moisture, and how much they
were beholden to rain for their growth, which
then being wanting, he might easily know there
would be a scarcity without the help of astrology;
yet if they will have it that Thales foreknew it
only by the science of this art, why are not others
who pretend to be so well skilled in its precepts,
as able to have the same opportunities of enriching
themselves? As for the foretelling the deaths
of emperors and others, it was but conjectures,
knowing most of them to be tyrants, and hated,
and thereupon would they pretend to promise to
others the empires and dignities, which sometimes
spurring up ambitious minds, they neglected no
attempts to gain the crown, the astrologers thereby
occasioning murders, add advancements by secret
instructions, rather than by any rules of art, which
they publicly pretended to, to gloss their actions
and advance the honour of their conjecturing
science: by the same manner might Ascletarion
have foretold the death of Domitian, and as for
himself being torn to pieces by dogs, it was but a
mere guess, for astrologers do not extend their
predictions beyond death, and therefore he did
not suppose his body would be torn to pieces after
his death, as it proved, but alive as a punishment
for his boldness in foretelling the death of the
emperor, which being a common punishment, had
it proved so, it had been by probability from
custom, but not of the rules of astrology.—<cite class="calibre12">See</cite>
<span class="sc">Blome</span>’s <cite class="calibre12">Body of Philosophy</cite>, pt. iii. chap. 14,
<em class="calibre12">in the history of Nature</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?5049b09b